import { ROUTES } from 'utils/constants';
import * as E360 from '@expert360';
import * as PathUtils from './pathUtils';

const queryString = require('query-string');

type User = {
  role?: E360.UserRoleV2 | null;
  consultant?: {
    lifecycle: Partial<E360.Lifecycle> | null;
  } | null;
};

const getHomePageForExpert = (user: User) => {
  const isPrivateCloudMember =
    user.consultant?.lifecycle?.privateCloudTalent ?? false;
  const isMarketplaceMember =
    user.consultant?.lifecycle?.marketplaceMember ?? false;

  const isPendingPrivateCloudMember =
    !isMarketplaceMember && !isPrivateCloudMember;

  const isAcceptedAndVerified =
    (user.consultant?.lifecycle?.accepted ?? false) &&
    (user.consultant?.lifecycle?.emailVerified ?? false);

  const basicProfileCompleted =
    user.consultant?.lifecycle?.basicProfileCompleted ?? false;

  if (isAcceptedAndVerified || isPrivateCloudMember) {
    return basicProfileCompleted
      ? ROUTES.expert.pendingProjects
      : ROUTES.profile.edit;
  }

  if (isPendingPrivateCloudMember) {
    return ROUTES.privateTalent.acceptTerms({ slug: 'redirect' });
  }

  return ROUTES.signUp.expertApplication;
};

const getRedirect = (user: User | null) => {
  const values = queryString.parse(window.location.search);

  /*
      XXX:
      The path specified in the `next` param is compared to the referrer to prevent a potential
      redirect loop in the edge case that a user is not allowed to view the page at `next`. If the
      user has been redirected to the login page from the path specified in `next`, ignore the
      `next` param and redirect the user to the default path for their role.
    */

  const role = user?.role ?? null;
  const roleFormatted = !!role ? role.toUpperCase() : null;

  if (values.next && !PathUtils.doPathsMatch(values.next, document.referrer)) {
    return values.next;
  }

  switch (roleFormatted) {
    case E360.UserRoleV2.Client:
      return ROUTES.client.index;
    case E360.UserRoleV2.Consultant:
      return getHomePageForExpert(user as User);
    case E360.UserRoleV2.Admin:
    case E360.UserRoleV2.Superadmin:
      return ROUTES.admin.index;
  }

  throw new Error(
    `Login: getRedirect expects a valid user role but received "${role}"`
  );
};

export default getRedirect;
